import Component from './Component'

export default class Password extends Component {

	static _type = 'Password'

	form			// Parent form component

	input_el		// DOM Elements
	feedback_el

	tether () {
		super.tether()

		// Own DOM elements
		this.input_el = this.base.querySelector('input')
		this.feedback_el = this.base.querySelector('.invalid-feedback')

		// Enclosing form
		this.form = this.base.closest('form[anvil-component]').anvil
		//this.form.registerInput(this.params.name, this)

		// Create bound event handlers and register them
		this.inputListener = Password._inputListener.bind(this)
		this.updateListener = Password._updateListener.bind(this)
		$(this.input_el).on('input', this.inputListener)								// jQuery event
		this.form.data.record.on(this.params.name + '-updated', this.updateListener)	// node event

		if ('init' in this.params && typeof this.params.init == 'function') {
			this.params.init(this)
		}
	}

	static _inputListener () {
		// Send data to the record
		this.form.data[this.params.name] = $(this.input_el).val()
	}

	static _updateListener (value, errors) {

		// If the value changed, update it on the input as well
		if ($(this.input_el).val() != value) {
			$(this.input_el).val(value)
		}

		// Render validation
		this.renderValidation(errors)

		// Update hook
		if ('update' in this.params && typeof this.params.update == 'function') {
			this.params.update(value, this.params.name, this.form.data, this.params)
		}
	}

	renderValidation (errors) {
		if (errors == null) {
			// Validation successful
			if (('prepend' in this.params || 'append' in this.params)) {
				$(this.base).find('.input-group').removeClass('is-invalid')
			}
			$(this.input_el).removeClass('is-invalid')
			$(this.feedback_el).html('')
		} else {
			// Invalid
			if (('prepend' in this.params || 'append' in this.params)) {
				$(this.base).find('.input-group').addClass('is-invalid')
			}
			$(this.input_el).addClass('is-invalid')
			$(this.feedback_el).html(errors.join('<br />'))
		}
	}

	destroy () {

		// Unregister event handlers
		$(this.input_el).off('input', this.inputListener)
		this.form.data.record.off(this.params.name + '-updated', this.updateListener)

		delete this.input_el
		delete this.feedback_el
		delete this.form

		super.destroy()
	}
}
